import React from "react";

export const ImportNotificationMessage = ({ content, isError }) => (
  <div>
    {isError === false
      ? "Successfully imported the following entities: "
      : "Failed to import the following entities: "}
    <ul>
      {content.map((entity, index) => {
        return (
          <li key={index}>
            {
              isError === false
                ? entity.name + ": " + entity.entitiesImportedCount
                : entity.name + ": " + entity.errorMessage
            }
          </li>
        );
      })}
    </ul>
  </div>
);
